module.exports = __webpack_public_path__ + "static/img/02.78ca371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250704/02.jpg
// module id = ao9C
// module chunks = 0